<template>
  <div>
    <slot v-bind="{archived, purchaseMode, switchPurchaseMode, archivedValue, productStatus, updateStocks}"></slot>
  </div>
</template>
<script>
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import {mapGetters, mapMutations, mapState, mapActions} from 'vuex';
import {ProductApi} from '@/api/product';
import ProductGroups from '@/components/containers/bulk-product/utils/product-groups';
import {updateStockWatchStatus} from '@/components/containers/bulk-product/utils/warehouses';

export default {
  props: {
    isBike: Boolean,
    baseProductCode: {
      type: String,
      required: true,
    },
    requestedProductCode: {
      type: String,
      default: () => '',
    },
    pdpFunctionsMapping: {
      type: Object,
      required: false,
      default: () => null,
    },
    rpaModalViewStockToggle: Boolean,
    electraAccessoryFinderToggle: Boolean,
    hasCustomWaterBottleRestriction: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      required: false,
      default: () => null,
    },
  },

  data() {
    return {
      productGroups: [],
      archived: '',
      productStatus: {},
    };
  },

  computed: {
    ...mapGetters('storage', ['purchaseMode']),
    ...mapState('backend', ['unitId', 'isConsumerFriendlyMode', 'b2b']),
    ...mapState('productDetails', ['searchResultReference']),
    ...mapState('compare', ['racks']),
    ...mapState('storage', ['purchaseMode']),

    isRackFull() {
      return this.racks[this.unitId].length === 4;
    },

    isInRack() {
      return !!find(this.racks[this.unitId], {productCode: this.productGroups.code});
    },
  },
  watch: {
    searchResultReference() {
      this.searchResultReference.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    },
  },

  mounted() {
    if (this.unitId !== 'b2c') {
      this.fetchProducts();
    }
    this.setCategory(this.category);
    this.setIsPDP(true);
    this.setIsBike(this.isBike);
    this.setRpaViewInStockModalValue(this.rpaModalViewStockToggle);
    this.updateRequestedProductCode(this.requestedProductCode);
    this.setElectraAccessoryFinderToggle(this.electraAccessoryFinderToggle);
    this.setPdpFunctionsMapping(this.pdpFunctionsMapping);
    this.setHasCustomWaterBottleRestriction(this.hasCustomWaterBottleRestriction);
    this.setPdpBaseProductCode(this.baseProductCode);
  },
  methods: {
    ...mapActions('skuGrid', ['loadAllocatedCounts']),
    ...mapActions('productDetails', ['setRpaViewInStockModalValue']),

    /**
     * Get product's ID from current URL.
     * @return {string|*}
     */
    getProductIdFromUrl() {
      const pathArray = window.location.pathname.split('/');
      const index = findIndex(pathArray, (x) => x === 'p');

      return index > -1 && pathArray.length > index + 1 ? pathArray[index + 1] : '';
    },

    /**
     * Update stock data.
     * @param payload
     */
    updateStocks(payload) {
      if (payload && payload.item) {
        updateStockWatchStatus(this.productGroups, payload.item);
      }
    },

    /**
     * Fetch product data.
     */
    fetchProducts() {
      const productId = this.getProductIdFromUrl();
      this.setBikeTechSKU(productId);

      if (this.baseProductCode) {
        ProductApi.loadProduct(this.baseProductCode, this.b2b).then((data) => {
          const productGroups = new ProductGroups(data);
          this.productGroups = productGroups.getProductGroups();

          this.productStatus = data.status;
        });

        this.loadAllocatedCounts([this.baseProductCode]);
      }
    },

    /**
     * Switch purchase mode  (consumer friendly on / off)
     * @param e
     */
    switchPurchaseMode(e) {
      this.togglePurchaseMode(e);
    },

    archivedValue(e) {
      this.archived = e;
    },

    ...mapActions('storage', ['togglePurchaseMode']),
    ...mapActions('productDetails', ['updateRequestedProductCode']),
    ...mapMutations('productDetails', [
      'setIsPDP',
      'setIsBike',
      'setElectraAccessoryFinderToggle',
      'setRpaViewInStock',
      'setPdpFunctionsMapping',
      'setCategory',
      'setPdpBaseProductCode',
    ]),
    ...mapMutations('backend', ['setHasCustomWaterBottleRestriction']),
    ...mapMutations('storage', ['setBikeTechSKU']),
  },
};
</script>
